import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { meInstoreOffer as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    getUnlinkOfferButtonText: (isMobileMQ) => (isMobileMQ ? 'Unlink offer' : 'Unlink this offer'),
    disclaimerTitle: 'In-store terms and conditions',
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
